// export const STAKING_CONTRACT = "0x948aB4FD2d19291Ead8D1B919B7b17Dbb14BfAa0"
export const STAKING_CONTRACT = "0x56F7ea503F42Ef66ff52f946FF3448b9654127e6"
export const GHO_CONTRACT = "0x88541670E55cC00bEEFD87eB59EDd1b7C511AC9a"